import axios from 'axios';
import { message } from 'antd';

const API_URL = process.env.REACT_APP_API_URL;

const api = axios.create({
    baseURL: API_URL,
    headers: { 'Content-Type': 'application/json' },
});

// 请求拦截器，添加签名认证 headers 和 token
api.interceptors.request.use(
    async (config) => {
        // 添加 token（适用于所有环境）
        const token = localStorage.getItem('token');
        if (token) {
            config.headers['X-Token-Header'] = token;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// 响应拦截器，处理 422 和 401 状态码
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && (error.response.status === 422 || error.response.status === 401)) {
            message.error('登录已过期，请重新登录');
            localStorage.removeItem('token');
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

// 许可证管理
export const getLicenses = (params) => api.get('/admin/licenses', { params });
export const createLicense = (data) => api.post('/admin/licenses', data);
export const updateLicense = (id, data) => api.put(`/admin/licenses/${id}`, data);
export const deleteLicense = (data) => api.delete(`/admin/licenses/delete`, {data: data});

// 激活管理
export const getActivations = (params) => api.get('/admin/activations', { params });
export const deleteActivation = (data) => api.delete(`/admin/activations`,{data: data});

// 用户管理
export const getUsers = (params) => api.get('/admin/users', { params });

// 审计日志管理
export const getAuditLogs = (params) => api.get('/admin/auditlogs', { params });

// 登录
export const login = (username, password) =>
    api.post('/admin/login', { username, password });

// 产品管理
export const getProducts = (params) => api.get('/admin/products', { params });
export const createProduct = (data) => api.post('/admin/products', data);
export const updateProduct = (id, data) => api.put(`/admin/products/${id}`, data);
export const deleteProduct = (data) => api.delete(`/admin/products`,{data: data});